import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

// Custom component to display each stat item
const StatItem = ({ label, value, color }) => {
  return (
   <Grid item xs={12} sm={6} md={6}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: '#f9f9f9',
          boxShadow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color }}>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {value}
        </Typography>
      </Box>
    </Grid>
  );
};

export default function FeeCollectionStatsModal({
  filtered_vouchers,
  open,
  setOpen,
}) {
  // Derived values
  const totalInvoices = filtered_vouchers?.length || 0;
  const totalAmount = filtered_vouchers.reduce((sum, voucher) => sum + (voucher.paid_amount || 0), 0);

  // Download as Excel (.xlsx)
  const handleDownload = () => {
    const stats = [
      ["Total Invoices", totalInvoices],
      ["Total Amount", totalAmount],
    ];
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Invoice Statistics", ""],
      ...stats,
    ]);

    worksheet["!cols"] = [{ width: 30 }, { width: 20 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Stats");
    XLSX.writeFile(workbook, "fee_stats.xlsx");
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle className="w-full text-center">
        Fee Collection Report Statistics
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <StatItem
            label="Total Invoices"
            value={totalInvoices}
            color="#D71920"
          />
          <StatItem
            label="Total Amount"
            value={`${totalAmount.toFixed(2)}`}
            color="#F7931E"
          />
        </Grid>

        <Box mt={3} display="flex" justifyContent="center">
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Download Stats
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
